'use client';

import { Box } from '@mui/material';
import { useState } from 'react';
import { ElementViewed } from '@repo/segment/Analytics/ElementViewed';
import type { MarketplaceBankingSubProductTypeEnum } from '@repo/supergraph-schemas/marketplace/enums';
import { PRODUCT_NAV_SECTION_MIN_HEIGHT_DESKTOP } from './constants';
import { ProductNavItem } from './ProductNavItem';

type Props = {
  subProducts: MarketplaceBankingSubProductTypeEnum[];
};

export const ProductNav = ({ subProducts }: Props) => {
  const [activeAnchorId, setActiveAnchorId] = useState<string>('');

  return (
    <ElementViewed entityName="anchor" sectionName="banking" pageType="review">
      <Box
        component="nav"
        aria-label="Product reviews navigation"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          width: '100%',
          minHeight: { xs: 'auto', md: PRODUCT_NAV_SECTION_MIN_HEIGHT_DESKTOP },
        }}
      >
        {subProducts.map(subProduct => (
          <ProductNavItem
            key={subProduct}
            subProduct={subProduct}
            activeAnchorId={activeAnchorId}
            setActiveAnchorId={setActiveAnchorId}
          />
        ))}
      </Box>
    </ElementViewed>
  );
};
